export default class Reader {
    constructor(code) {
        this.code = code;
        this.position = 0;
    }
    forward() {
        if (this.code.length === this.position) {
            return { char: '', isEOS: true };
        }
        const char = this.code.charAt(this.position);
        this.position += 1;
        return {
            char,
            isEOS: false
        };
    }
    backward() {
        if (this.position === 0) {
            throw new RangeError();
        }
        const char = this.code.charAt(this.position);
        this.position -= 1;
        return {
            char,
            isEOS: false
        };
    }
    getPosition() {
        return this.position;
    }
}
//# sourceMappingURL=reader.js.map